module.exports = __webpack_public_path__ + "assets/battery.7aa60be5.svg";